import http from './http'
import {
  buildArchiveDetailParams,
  buildArchiveListParams,
  buildRelatedArchiveParams
} from '@/utils/archive'
import {
  buildTagDataListParams,
  buildTagDetailParams,
  buildTagListParams
} from '@/utils/tag'
import { anqicmsConfig } from '@/config/anqicms'

function withModuleId(params = {}) {
  if (params.moduleId !== undefined && params.moduleId !== null && params.moduleId !== '') {
    return params
  }
  if (anqicmsConfig.moduleId) {
    return { ...params, moduleId: anqicmsConfig.moduleId }
  }
  return params
}

/**
 * 获取文档列表
 * type=page 分页（返回 total）；type=list 固定条数；type=related 相关文档
 */
export function fetchArchiveList(params = {}) {
  const normalized =
    params.type === 'related'
      ? buildRelatedArchiveParams(params.id, params)
      : buildArchiveListParams(params)

  return http.get('/archive/list', { params: withModuleId(normalized) })
}

/**
 * 文档详情
 * 支持 id 或 filename；id + filename=prev/next 可获取上一篇/下一篇
 */
export function fetchArchiveDetail(params = {}) {
  return http.get('/archive/detail', {
    params: buildArchiveDetailParams(params)
  })
}

/** 上一篇（通过 detail 接口 filename=prev） */
export function fetchArchivePrev(params) {
  return fetchArchiveDetail({
    id: params.id,
    filename: 'prev',
    render: false
  })
}

/** 下一篇（通过 detail 接口 filename=next） */
export function fetchArchiveNext(params) {
  return fetchArchiveDetail({
    id: params.id,
    filename: 'next',
    render: false
  })
}

/** 相关文档 */
export function fetchRelatedArchives(params) {
  return fetchArchiveList(buildRelatedArchiveParams(params.id, params))
}

/** 分类列表 */
export function fetchCategoryList(params = {}) {
  return http.get('/category/list', { params: withModuleId(params) })
}

/** 分类详情 */
export function fetchCategoryDetail(params) {
  return http.get('/category/detail', { params })
}

/** Banner 列表 */
export function fetchBannerList(params = {}) {
  return http.get('/banner/list', {
    params: {
      type: params.type || 'default',
      ...params
    }
  })
}

/** 系统设置 */
export function fetchSystemSetting() {
  return http.get('/setting/system')
}

/** 首页设置 */
export function fetchIndexSetting() {
  return http.get('/setting/index')
}

/** 系统设置 */
export function fetchConfigSetting() {
  return http.get('/setting/system')
}

/** 导航列表 */
export function fetchNavList(params = {}) {
  return http.get('/nav/list', {
    params: {
      type_id: params.type_id !== undefined ? params.type_id : 1,
      ...params
    }
  })
}

/** 单页详情 */
export function fetchPageDetail(params) {
  return http.get('/page/detail', { params })
}

/**
 * 标签列表
 * @see https://www.anqicms.com/anqiapi-tag/147.html
 */
export function fetchTagList(params = {}) {
  return http.get('/tag/list', { params: buildTagListParams(params) })
}

/**
 * 标签详情
 * @see https://www.anqicms.com/anqiapi-tag/148.html
 */
export function fetchTagDetail(params = {}) {
  return http.get('/tag/detail', { params: buildTagDetailParams(params) })
}

/**
 * 标签下的文档列表
 * @see https://www.anqicms.com/anqiapi-tag/149.html
 */
export function fetchTagDataList(params = {}) {
  return http.get('/tag/data/list', { params: buildTagDataListParams(params) })
}

/** 留言咨询 */
export function submitGuestbook(params) {
  return http.post('/guestbook.html', params)
}
